export default "/images/8933fba6ca23ebec203426288c602127.avif";